import { dashOrSpaceToUnderscore } from 'Utilities'

import { getReturnCase_returnCaseItem } from 'Constants/graphql/queries/detail/__generated__/getReturnCase'
import { getReturnCasePreviewColumn_returnCaseItem } from 'Constants/graphql/queries/detail/__generated__/getReturnCasePreviewColumn'

import {
  ReturnCaseStatus,
  ReturnCaseSubstatus,
} from 'Portal/__generated__/globalTypes'

import { ReturnsWithUrl } from '../ReturnsTable/ReturnsTable.types'

export const isReturnBlocked = (
  returnCase:
    | getReturnCase_returnCaseItem
    | getReturnCasePreviewColumn_returnCaseItem
    | ReturnsWithUrl
    | undefined,
) => {
  if (!returnCase || !returnCase.substatus) {
    return false
  }

  const returnCaseSubstatus = dashOrSpaceToUnderscore(returnCase.substatus)

  return (
    returnCase.status === ReturnCaseStatus.blocked &&
    (returnCaseSubstatus === ReturnCaseSubstatus.in_customer_lock ||
      returnCaseSubstatus === ReturnCaseSubstatus.in_mdm ||
      returnCaseSubstatus === ReturnCaseSubstatus.in_mdm_and_customer_lock)
  )
}
